export const isFirst = <T extends unknown>(line: T, lines: T[]) => {
	return line === lines[0];
};
